<div>
  <form #nf="ngForm" novalidate>
   

    <div class="row m-0 col-md-12 p-0 formborder">
      <!-- <div class="col-md-4">
        <span class="required-lable">Vehicle Category</span>
        <input
          type="text"
          name="SelectVehicleCategory"
          id="SelectVehicleCategory"
          [(ngModel)]="SelectVehicleCategory"
          class="form-control input-text-css"
          #refSelectVehicleCategory="ngModel"
          required
          [ngClass]="{
            'is-invalid': f.submitted && refSelectVehicleCategory.invalid,
            'alert-warning':
              refSelectVehicleCategory.invalid &&
              (refSelectVehicleCategory.dirty ||
                refSelectVehicleCategory.touched ||
                refSelectVehicleCategory.untouched)
          }"
        />
      </div> -->
       <div class="col-md-4">
      <button
          type="button"
          (click)="AddNewVehicleCategory()"
          class="mt-3 btn font-size-12 button-btn"
          [class.spinner]="loading"
        >
          Add Vehicle Category
        </button>
    </div>
      <!-- <div class="col-md-4">
        <button
          type="button"
          (click)="onSaveVehicleCatData()"
          *ngIf="saveBtn"
          class="mt-3 btn font-size-12 button-btn"
          [class.spinner]="loading"
          [disabled]="!f.form.valid"
        >
          Save
        </button>
        <button
          type="button"
          (click)="UpdateVehicleCategory()"
          *ngIf="updateBtn"
          class="mt-3 btn font-size-12 button-btn"
          [class.spinner]="loading"
          [disabled]="!f.form.valid"
        >
          Update
        </button>
      </div> -->

      <div class="col-md-4 p-1 mt-2">
       
        <form action="" class="search-text">
          <div class="bg-light rounded rounded-pill shadow-sm">
            <div class="input-group">
              <input
                type="text"
                id="FilterInputSearch"
                (keyup)="applyFilter($event.target.value)"
                name="FilterInputSearch"
                placeholder="What're you searching for?"
                class="form-control border-0 bg-light"
              />
              <div class="input-group-append">
                <button
                  id="button-addon1"
                  type="submit"
                  class="btn btn-link text-primary"
                >
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </form>
  
  <div class="modal fade in" id="VehicleCategoryMaster" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 10px">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
         Add Vehicle Category
        </h6>
        <button type="button" (click)="onclose()" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><i class="far text-black fa-times-circle"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <form #f="ngForm">
          <div class="row m-0 mb2">
            <div class="row m-0 col-md-12 p-1">
              <div class="table-responsive">
                <ng-container>
                  <div class="row m-0 mt-1">
                <div class="col-md-3 p-1">
                  <span class="required-lable">Vehicle Category</span>
                  <input
                    type="text"
                    placeholder="Vehicle Category"
                    name="SelectVehicleCategory"
                    id="SelectVehicleCategory"
                    [(ngModel)]="SelectVehicleCategory"
                    class="form-control input-text-css"
                    #refSelectVehicleCategory="ngModel"
                    required
                    [ngClass]="{
                      'is-invalid': f.submitted && refSelectVehicleCategory.invalid,
                      'alert-warning':
                        refSelectVehicleCategory.invalid &&
                        (refSelectVehicleCategory.dirty ||
                          refSelectVehicleCategory.touched ||
                          refSelectVehicleCategory.untouched)
                    }"
                  />
                </div>
                <div class="col-md-3 p-1">
                  <span class="required-lable">Vehicle Category Type</span>
                  <select name="Vehicle_Category_Type" #refVehicle_Category_Type="ngModel" [(ngModel)]="Vehicle_Category_Type"
                    required
                      [ngClass]="{
                        'is-invalid': f.submitted && refVehicle_Category_Type.invalid,
                        'alert-warning':
                          refVehicle_Category_Type.invalid &&
                          (refVehicle_Category_Type.dirty ||
                            refVehicle_Category_Type.touched ||
                            refVehicle_Category_Type.untouched)
                      }" class="form-control input-text-css">
                    <option value="">Vehicle Category Type</option>
                    <option *ngFor="let data of VehicleCategoryTypeData" [value]="data.Id">
                      {{ data.Vehicle_Category_Type }}
                    </option>
                  </select>
                </div>
                </div>
                    <!-- <div class="col-md-3 p-1">
                      <span class="required-lable">Select City</span>
                      <select name="CityId" #refCityId="ngModel" [(ngModel)]="SelectedCityId" (change)="OnCityChange()"
                        required [disabled]="IsDisabled || SelectedValuationCategoryId === 'Kast'" [ngClass]="{
                            'is-invalid': f.submitted && refCityId.invalid,
                            'alert-warning':
                              refCityId.invalid &&
                              (refCityId.dirty ||
                                refCityId.touched ||
                                refCityId.untouched)
                          }" class="form-control input-text-css">
                        <option value="">Select City</option>
                        <option *ngFor="let data of CityList" [value]="data.id">
                          {{ data.name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-3 p-1">
                      <span class="required-lable">Select Area</span>
                      <select name="AreaId" #refAreaId="ngModel" [(ngModel)]="SelectedAreaId" required
                        [disabled]="IsDisabled || SelectedValuationCategoryId === 'Kast'" [ngClass]="{
                            'is-invalid': f.submitted && refAreaId.invalid,
                            'alert-warning':
                              refAreaId.invalid &&
                              (refAreaId.dirty ||
                                refAreaId.touched ||
                                refAreaId.untouched)
                          }" class="form-control input-text-css">
                        <option value="">Select Area</option>
                        <option *ngFor="let data of AreaList" [value]="data.id">
                          {{ data.name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-3 p-1">
                      <span class="required-lable">Select Client City</span>
                      <select name="ClientCityId" #refClientCityId="ngModel" [(ngModel)]="SelectedClientCityId" required
                        [disabled]="IsDisabled || SelectedValuationCategoryId === 'Kast'" [ngClass]="{
                            'is-invalid': f.submitted && refClientCityId.invalid,
                            'alert-warning':
                              refClientCityId.invalid &&
                              (refClientCityId.dirty ||
                                refClientCityId.touched ||
                                refClientCityId.untouched)
                          }" class="form-control input-text-css">
                        <option value="">Select City</option>
                        <option *ngFor="let data of CityList" [value]="data.id">
                          {{ data.name }}
                        </option>
                      </select>
                    </div> -->

                  
                  <!-- <div class="text-right mb-2" style="margin-right: 50px">
                    <button type="button" (click)="onSaveVehicleCatData()" class="btn font-size-12 button-btn"
                      [class.spinner]="loading" [disabled]="!f.form.valid">
                      Save
                    </button>
                  </div> -->
                  <div  class="text-right mb-2" style="margin-right: 50px">
                    <button
                      type="button"
                      (click)="onSaveVehicleCatData()"
                      *ngIf="saveBtn"
                      class="mt-3 btn font-size-12 button-btn"
                      [class.spinner]="loading"
                      [disabled]="!f.form.valid"
                    >
                      Save
                    </button>
                    <button
                      type="button"
                      (click)="UpdateVehicleCategory()"
                      *ngIf="updateBtn"
                      class="mt-3 btn font-size-12 button-btn"
                      [class.spinner]="loading"
                      [disabled]="!f.form.valid"
                    >
                      Update
                    </button>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
  <div class="table-responsive mt-2">
    <mat-table [dataSource]="dataCustomerSource">
      <ng-container matColumnDef="Number">
        <mat-header-cell
          class="grid-header"
          style="max-width: 50px"
          *matHeaderCellDef
        >
          #
        </mat-header-cell>
        <mat-cell
          *matCellDef="let row; let i = index"
          class="grid-cell"
          style="max-width: 50px; max-height: 5px"
        >
          {{ i + 1 }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Vehicle Category">
        <mat-header-cell class="grid-header" *matHeaderCellDef
          >Vehicle Category</mat-header-cell
        >
        <mat-cell *matCellDef="let row" class="grid-cell">{{
          row.Vehicle_Category
        }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="Vehicle Category Type">
        <mat-header-cell class="grid-header" *matHeaderCellDef
          >Vehicle Category Type</mat-header-cell
        >
        <mat-cell *matCellDef="let row" class="grid-cell">{{
          row.Vehicle_Category_Type
        }}</mat-cell>
      </ng-container>

      <!--<ng-container matColumnDef="Vehicle Manufacture">
            <mat-header-cell class="grid-header" style="max-width: 200px;max-height:5px" *matHeaderCellDef>Vehicle Manufacture</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell" style="max-width: 200px;max-height:5px">{{row.Manufacture}}</mat-cell>
          </ng-container>-->

      <ng-container matColumnDef="Action">
        <mat-header-cell class="grid-header j-c-center" *matHeaderCellDef
          >Action</mat-header-cell
        >
        <mat-cell *matCellDef="let row" class="grid-cell j-c-center">
          <i
            class="fas fa-lg fa-edit margin-right-4xs cursor-style"
            aria-label="true"
            (click)="editVehicleCat(row)"
          ></i>
          <i
            class="fa fa-trash style-delete"
            (click)="removeVehicleCat(row)"
            aria-label="true"
          ></i>
        </mat-cell>
      </ng-container>
      <mat-header-row
        *matHeaderRowDef="displayedCustomerColumns"
      ></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: displayedCustomerColumns"
      ></mat-row>
    </mat-table>
  </div>
</div>

<div class="row m-0 mt-3 formborder" [hidden]="!dataCustomerSource">
  <div class="col-md-4 mt-3">
    <button class="mt-3 btn font-size-12 button-btn" (click)="exportexcelNew()">
      <i
        class="fa fa-file-export mr-1"
        style="font-size: medium; cursor: pointer"
      ></i>
      Export
    </button>
  </div>
  <!-- <div class="col-md-8 mt-3">
    <mat-paginator
      #paginatorRef
      [pageSizeOptions]="[20, 50]"
      showFirstLastButtons
    ></mat-paginator>
  </div> -->
</div>

<table
  id="export_vehicle_category"
  class="table table-bordered bg-white"
  style="font-family: 'Times New Roman', Times, serif; display: none"
>
  <tr>
    <th style="background: #4dc3a3 !important; border: 1px solid white">#</th>
    <th style="background: #4dc3a3 !important; border: 1px solid white">
      Vehicle Category
    </th>
  </tr>
  <tr *ngFor="let x of JsonData; let i = index">
    <td>{{ i + 1 }}</td>
    <td>{{ x.Vehicle_Category }}</td>
  </tr>
</table>
